<template>
  <div class="login-box">
    <div class="login-logo">
      <router-link to="/">
        <b>Mister</b> Aladin
      </router-link>
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <template v-if="isInvalid">
        <p class="text-center">
          <i class="fa fa-fw fa-exclamation-triangle"></i> {{errorMessage}}
        </p>
      </template>

      <template v-else>
        <p class="login-box-msg">Please provide your new password</p>
        <form @submit.prevent="reset">
          <div v-if="errorMessage" class="alert alert-danger">
            <a class="close" @click="errorMessage = false">&times;</a>
            {{ errorMessage }}
          </div>

          <div class="form-group has-feedback">
            <input
              ref="password"
              type="password"
              class="form-control"
              placeholder="Password"
              v-model="password">
            <span class="form-control-feedback" @click="togglePassword">
              <i class="glyphicon glyphicon-eye-open" v-if="showPassword"></i>
              <i class="glyphicon glyphicon-eye-close" v-else></i>
            </span>
          </div>
          <div class="row">
            <!-- /.col -->
            <div class="col-xs-4">
              <button type="submit" class="btn btn-primary btn-block btn-flat">Submit</button>
            </div>
            <!-- /.col -->
          </div>
        </form>
      </template>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
          password: null,
          errorMessage: null,
          isInvalid: false,
          inputType: 'password',
          showPassword: false,
        };
    },
    methods: {
      check() {
        this.axios.get(`/auth/password/reset?email=${this.$route.query.email}&token=${this.$route.query.token}`)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error.response.data.errors);
          // console.log(error.response.status);

          this.isInvalid = true;
          this.errorMessage = error.response.data.errors;
          setTimeout(() => {
            this.$router.push('/login');
          }, 5000);
        });
      },
      reset() {
        const credentials = {
          email: this.$route.query.email,
          token: this.$route.query.token,
          password: this.password,
        };

        this.axios.post('/auth/password/reset', qs.stringify(credentials))
          .then((response) => {
            this.$swal({
              title: 'Success',
              text: 'Your password sucessfully changed.',
              type: 'success',
              onClose: () => {
                  this.$router.push('/login');
                },
              });

            console.log(response);
          })
          .catch((error) => {
            this.$swal('Error', error.response.data.errors, 'error');
            console.log(error.response.data.errors);
          });
      },
      togglePassword() {
        console.log('Klik password');
        this.showPassword = !this.showPassword;
        this.inputType = (this.inputType === 'password') ? 'text' : 'password';
        console.log(this.inputType);
        this.$refs.password.setAttribute('type', this.inputType);
      },
    },
    created() {
      this.check();
    },
};
</script>

<style scoped>
  .login-box-body .form-control-feedback,
  .register-box-body .form-control-feedback {
    pointer-events: all;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reset.vue